module.exports = __webpack_public_path__ + "img/baccarat icon 2.ff90ad8e.png";